import axios from 'axios';
// axios默认请求域名
// axios.defaults.baseURL = '//project-test.gamersky.com/Appointment/LotteryActivity/'
axios.defaults.baseURL = "//appapi2.gamersky.com/shop/"
// axios请求是否携带cookie
axios.defaults.withCredentials = true;

const ajax = {
    // post: function (url, data = {}) {
    //     return new Promise((resolve, reject) => {
    //         axios.post(url, data)
    //             .then((response) => {
    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //             });
    //     })
    // },
    post: function (url, data = {}, headers = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, data, headers)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },

    get: function (url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },

    jsonp: function (url, data = {}) {
        if (!url)
            throw new Error('url is necessary')
        const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
        const JSONP = document.createElement('script')
        JSONP.setAttribute('type', 'text/javascript')

        const headEle = document.getElementsByTagName('head')[0]
        let ret = '';
        if (data) {
            if (typeof data === 'string')
                ret = '&' + data;
            else if (typeof data === 'object') {
                for (let key in data)
                    ret += '&' + key + '=' + encodeURIComponent(data[key]);
            }
            ret += '&_=' + Date.now();
        }
        JSONP.src = `${url}?callback=${callback}${ret}`;
        return new Promise((resolve) => {
            window[callback] = r => {
                resolve(r)
                headEle.removeChild(JSONP)
                delete window[callback]
            }
            headEle.appendChild(JSONP)
        })
    },
    
    CrossPost: function (url, data = {}) {
        return new Promise((resolve, reject) => {
            ajax.post("//instrument.gamersky.com/HTTPHelper/CrossPost", {
                url: url,
                postData: JSON.stringify(data)
            }).then(response => {
                response = JSON.parse(response);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    }
    
};


// // 请求拦截器
// axios.interceptors.request.use(request => {
//     if(request.url.indexOf('Users') === -1) {
//         request.data['userOpenId'] = ajax.storage.get('userInfo').UserOpenId;
//         request.data['sessionToken'] = ajax.storage.get('userInfo').SessionToken;
//     }
//     return request
// }, (error) => {
//     return Promise.reject(error);
// });

// // 响应拦截器
// axios.interceptors.response.use(function (response) {
//     // if (response.data.Error != "") {
//     //     localStorage.removeItem('userInfo')
//     //     Vue.$router.replace({name: 'login'})
//     // }
//     return response;
// }, function (error) {
//     return Promise.reject(error);
// });


export default ajax;